export const clearKycFlow = (dispatch) => {
  dispatch({ type: "SET_KYC_DETAILS", payload: null });
  dispatch({ type: "SET_KYC_METHOD", payload: null });
  dispatch({ type: "SET_AADHAAR_RESUME", payload: null });
  dispatch({ type: "SET_MANUAL_DRAFT", payload: null });
};

export const clearGstInputs = (dispatch) => {
  dispatch({ type: "RESET_OPERATIONAL_DETAILS" });
  dispatch({ type: "RESET_PAN_DETAILS" });
  dispatch({ type: "SET_GST_NUMBER", payload: null });
  dispatch({ type: "SET_GST_DETAILS", payload: null });
};

export const backToUserDetails = (dispatch) => {
  clearKycFlow(dispatch);
  clearGstInputs(dispatch);
  dispatch({ type: "SET_ONBOARD_ACTIVE_STEP", payload: 1 });
};

export const backToRole = (dispatch) => {
  clearKycFlow(dispatch);
  clearGstInputs(dispatch);
  dispatch({
    type: "SET_USER_DETAIL_FIELD",
    payload: { field: "name", value: "" },
  });
  dispatch({
    type: "SET_USER_DETAIL_FIELD",
    payload: { field: "mobileNumber", value: "" },
  });
  dispatch({ type: "SET_ONBOARD_ACTIVE_STEP", payload: 0 });
};

export const backToAadhaar = (dispatch, resume) => {
  dispatch({ type: "SET_KYC_DETAILS", payload: null });
  dispatch({
    type: "SET_KYC_METHOD",
    payload: resume === "manual" ? "AADHAAR_MANUAL" : "AADHAAR_OCR",
  });
  dispatch({ type: "SET_AADHAAR_RESUME", payload: resume });
  if (resume !== "manual") dispatch({ type: "SET_MANUAL_DRAFT", payload: null });
  dispatch({ type: "SET_ONBOARD_ACTIVE_STEP", payload: 1 });
};

export const backToGstInput = (dispatch) => {
  dispatch({ type: "SET_KYC_DETAILS", payload: null });
  clearGstInputs(dispatch);
};
